import { useEffect, useState } from "react";
import { IAdjustment2Config } from "../../../Interfaces/deltaHedgeAdjustment";
import {
  getAdjustment2Config,
  getAdjustmentConfig,
  setAdjustment2Config,
  setAdjustmentConfig,
} from "../../../Requests/deltaHedgeAdjustment";
import { packetErrorHandler } from "../../../Utils/requestUtils";
import TextInput from "../../../Components/TextInput";
import Button from "../../../Components/Button";
import { toast } from "react-toastify";
import FullScreenLoading from "../../../Components/Loading/FullScreenLoading";

interface IProps {
  onClose: () => void;
}

const Adjustment2Config = ({ onClose }: IProps) => {
  const [formValues, setFormValues] = useState({} as IAdjustment2Config);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    getAdjustment2Config()
      .then((resp) => {
        setFormValues(resp);
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  }, []);

  const changeHandler = (name: string, value: any) => {
    const nameParts = name.split(".");
    setFormValues({
      ...formValues,
      [nameParts[0]]: {
        ...formValues[nameParts[0] as keyof IAdjustment2Config],
        [nameParts[1]]: value,
      },
    });
  };

  const submitHandler = () => {
    setLoading(true);
    setAdjustment2Config(formValues)
      .then((resp) => {
        if (resp.data) {
          toast.success(resp.msg);
          onClose();
        } else toast.error(resp.msg);
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };

  const getForm = (
    title: string,
    fieldName: Exclude<keyof IAdjustment2Config, "buyBase" | "sellBase">
  ) => (
    <div className="grid grid-cols-6 gap-x-2 gap-y-3 w-full border-b border-gray-400 pb-3">
      <div className="font-bold">{title}</div>
      <div />
      <div />
      <div />
      <div />
      <div />
      <TextInput
        label="حداقل بازده قفل روزانه خرید (تقویت)"
        name={`${fieldName}.minDailyLockProfitReinforcement`}
        value={formValues[
          fieldName
        ]?.minDailyLockProfitReinforcement?.toString()}
        onChange={changeHandler}
        extraLabel
      />
      <TextInput
        label="حداقل بازده قفل روزانه خرید (خنثی-همجنس-هم سررسید)"
        name={`${fieldName}.minDailyLockProfitSameKind`}
        value={formValues[fieldName]?.minDailyLockProfitSameKind?.toString()}
        onChange={changeHandler}
        extraLabel
      />
      <TextInput
        label="حداقل بازده قفل روزانه خرید (خنثی-غیر همجنس)"
        name={`${fieldName}.minDailyLockProfitDifferentKind`}
        value={formValues[
          fieldName
        ]?.minDailyLockProfitDifferentKind?.toString()}
        onChange={changeHandler}
        extraLabel
      />
      <TextInput
        label="حداقل بازده قفل روزانه خرید (خنثی-همجنس-غیر هم سررسید)"
        name={`${fieldName}.minDailyLockProfitDifferentApplyDay`}
        value={formValues[
          fieldName
        ]?.minDailyLockProfitDifferentApplyDay?.toString()}
        onChange={changeHandler}
        extraLabel
      />
      <TextInput
        label="حداقل بازده قفل روزانه خرید (تضعیف)"
        name={`${fieldName}.minDailyLockProfitDifferentWeak`}
        value={formValues[
          fieldName
        ]?.minDailyLockProfitDifferentWeak?.toString()}
        onChange={changeHandler}
        extraLabel
      />
      <TextInput
        label="مرز حباب نرمال نسبی"
        name={`${fieldName}.relativeNormalBubbleTreshold`}
        value={formValues[fieldName]?.relativeNormalBubbleTreshold?.toString()}
        onChange={changeHandler}
        extraLabel
      />
      <TextInput
        label="حداقل قدرمطلق اختلاف حباب"
        name={`${fieldName}.minAbsDiffrential`}
        value={formValues[fieldName]?.minAbsDiffrential?.toString()}
        onChange={changeHandler}
        extraLabel
      />
      <TextInput
        label="حداقل قدرمطلق دلتا"
        name={`${fieldName}.minAbsDelta`}
        value={formValues[fieldName]?.minAbsDelta?.toString()}
        onChange={changeHandler}
        extraLabel
      />
      <TextInput
        label="حداقل حجم روز معاملاتی قبل"
        name={`${fieldName}.minLastTrade`}
        value={formValues[fieldName]?.minLastTrade?.toString()}
        onChange={changeHandler}
        extraLabel
      />
      <TextInput
        label="حداقل روز تا سررسید"
        name={`${fieldName}.minRemainingDay`}
        value={formValues[fieldName]?.minRemainingDay?.toString()}
        onChange={changeHandler}
        extraLabel
      />
      <TextInput
        label="حداکثر روز تا سررسید"
        name={`${fieldName}.maxRemainingDay`}
        value={formValues[fieldName]?.maxRemainingDay?.toString()}
        onChange={changeHandler}
        extraLabel
      />
    </div>
  );

  return (
    <div className="flex flex-col justify-center items-start gap-3 pb-3">
      {loading ? <FullScreenLoading /> : <></>}
      {getForm("خرید کال و پایه", "buyCall")}
      {getForm("فروش کال", "sellCall")}
      {getForm("خرید پوت", "buyPut")}
      {getForm("فروش پوت", "sellPut")}

      <div className="mr-auto w-24">
        <Button text="ثبت" onClick={submitHandler} variant="contained" />
      </div>
    </div>
  );
};

export default Adjustment2Config;
